import { render, staticRenderFns } from "./CustomFieldCheckbox.vue?vue&type=template&id=73fc6277&lang=pug&"
import script from "./CustomFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomFieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports